import Header from 'semantic-ui-react/dist/commonjs/elements/Header'
export default Header
